module.exports = __webpack_public_path__ + "img/lADP.c567363f.jpg";